import NamedDto from 'modules/base/dto/NamedDto';

export class VizsgaEditDto extends NamedDto {
	/**
	 * @module VizsgaEditDto
	 */
	constructor() {
		super();
		/** @type {string} */
		this.leiras = null;
		/** @type {Date} */
		this.datum = null;
		/** @type {string} */
		this.nyitolap = null;
		/** @type {number} */
		this.kKarId = null;
		/** @type {boolean} */
		this.nyomtatvaIn = null;
		/** @type {boolean} */
		this.lezarvaIn = null;
		/** @type {number} */
		this.kettes = null;
		/** @type {number} */
		this.harmas = null;
		/** @type {number} */
		this.negyes = null;
		/** @type {number} */
		this.otos = null;
		/** @type {boolean} */
		this.tesztlapMegnezhetoIn = null;
		/** @type {Date} */
		this.reklamacioLezarasDatum = null;
		/** @type {Date} */
		this.vizsgaKezdesDatum = null;
		/** @type {number} */
		this.vizsgaIdo = null;
		/** @type {number} */
		this.vizsgaKezdesVarakozas = null;
	}

	/**
	 * @typedef {Object} _VizsgaEditDtoProps
	 * @property {string} leiras
	 * @property {Date} datum
	 * @property {number} kKarId
	 * @property {boolean} nyomtatvaIn
	 * @property {boolean} lezarvaIn
	 * @property {number} kettes
	 * @property {number} harmas
	 * @property {number} negyes
	 * @property {number} otos
	 * @property {boolean} tesztlapMegnezhetoIn
	 * @property {Date} reklamacioLezarasDatum
	 * @property {Date} vizsgaKezdesDatum
	 * @property {number} vizsgaIdo
	 * @property {number} vizsgaKezdesVarakozas
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _VizsgaEditDtoProps} VizsgaEditDtoProps
	 */
	/**
	 *
	 * @param {VizsgaEditDtoProps} props
	 * @returns {VizsgaEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.leiras = props.leiras;
		this.nyitolap = props.nyitolap;
		this.datum = props.datum !== null ? new Date(props.datum) : null;
		this.kKarId = props.kKarId;
		this.nyomtatvaIn = props.nyomtatvaIn;
		this.lezarvaIn = props.lezarvaIn;
		this.kettes = props.kettes;
		this.harmas = props.harmas;
		this.negyes = props.negyes;
		this.otos = props.otos;
		this.tesztlapMegnezhetoIn = props.tesztlapMegnezhetoIn;
		this.reklamacioLezarasDatum = props.reklamacioLezarasDatum !== null ? new Date(props.reklamacioLezarasDatum) : null;
		this.vizsgaKezdesDatum = props.vizsgaKezdesDatum !== null ? new Date(props.vizsgaKezdesDatum) : null;
		this.vizsgaIdo = props.vizsgaIdo;
		this.vizsgaKezdesVarakozas = props.vizsgaKezdesVarakozas;
		return this;
	}
}

export default VizsgaEditDto;
